import { PermitExempt, ScopeType } from '@EcamModel/model/PermitExempt';

const getScopeDisplayContent = (item: PermitExempt) => {
    switch (item.ScopeType) {
        case ScopeType.Location:
            return {
                location: item.Location?.Name ?? '-',
                zone: '-',
                camera: '-',
                geoZone: '-',
            };
        case ScopeType.Zone:
            return {
                location: item.Zone?.Location?.Name ?? '-',
                zone: item.Zone?.PublicName ?? '-',
                camera: '-',
                geoZone: '-',
            };
        case ScopeType.Camera:
            return {
                location: item.Camera?.Zone?.Location?.Name ?? '-',
                zone: item.Camera?.Zone?.PublicName ?? '-',
                camera: item.Camera?.Name ?? '-',
                geoZone: '-',
            };
        case ScopeType.GeoZone:
            return {
                location: item.GeoZone?.Camera?.Zone?.Location?.Name ?? '-',
                zone: item.GeoZone?.Camera?.Zone?.PublicName ?? '-',
                camera: item.GeoZone?.Camera?.Name ?? '-',
                geoZone: item.GeoZone?.GeoZoneName ?? '-',
            };
        case ScopeType.Global:
            return {
                location: 'Global',
                zone: '-',
                camera: '-',
                geoZone: '-',
            };
        default:
            return {
                location: '-',
                zone: '-',
                camera: '-',
                geoZone: '-',
            };
    }
};

export { getScopeDisplayContent };
